<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="onCloseModal"
    :modalId="'reorder-banner'"
  >
    <template #modal-header>
      <div class="reorder-banner-header-label">
        Reorder to
        <b-col cols="14" class="mt-1">
          <div class="d-flex">
            <div class="p-relative mr-4">
              <b-form-input v-model="currentIndex" disabled />
            </div>
            <arrow-icon class="arrow-icon" />
            <div class="p-relative">
              <b-form-input @keypress="isNumber($event)" v-model="newIndex" />
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="reorder-action">
            <save-button
              :loading="loading"
              class="mr-1 action-button"
              @click.native="reorderAction(currentIndex, newIndex)"
            />
            <b-button
              class="action-button"
              variant="outline-danger"
              @click="onCloseModal"
            >
              <span>Cancel</span>
            </b-button>
          </div>
        </b-col>
      </div>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@core/components/base-modal/BaseModal.vue';
  import { BRow, BCol, BSpinner, BFormInput, BButton } from 'bootstrap-vue';
  import CardNoItem from '@core/components/card-no-item/CardNoItem.vue';
  import ArrowIcon from '@/@core/components/svg/common/Arrow.vue';
  import SaveButton from '@/views/components/button/SaveButton.vue';

  import { ref, getCurrentInstance } from '@vue/composition-api';

  export default {
    props: {
      currentIndex: Number,
      reorderAction: Function,
      loading: { type: Boolean, default: false },
    },
    components: {
      BRow,
      BCol,
      BSpinner,
      BFormInput,
      BButton,
      SaveButton,
      BaseModal,
      CardNoItem,
      ArrowIcon,
    },
    setup() {
      const newIndex = ref(null);
      const vm = getCurrentInstance().proxy;

      const isNumber = (e) => {
        let char = String.fromCharCode(e.keyCode);

        if (/^[0-9]+$/.test(char)) {
          return true;
        }

        e.preventDefault();
      };

      const onCloseModal = () => {
        newIndex.value = null;
        vm.$emit('onCloseModal');
      };

      return {
        newIndex,
        isNumber,
        onCloseModal,
      };
    },
  };
</script>

<style>
  @import '~@/assets/css/override-styles/reorder-modal.css';
</style>
